import {
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO pour créer une adhésion de classe
 */
export class CreateClassMembershipDto {
  @ApiProperty({ type: 'string', description: 'ID classe' })
  @IsNotEmpty()
  @IsUUID('4')
  classId!: string

  @ApiProperty({ type: 'string', description: 'ID utilisateur' })
  @IsNotEmpty()
  @IsString()
  userId!: string

  @ApiProperty({ type: 'string', description: 'ID rôle' })
  @IsNotEmpty()
  @IsUUID('4')
  roleId!: string

  @ApiPropertyOptional({ type: Boolean, description: 'Délégué de classe' })
  @IsOptional()
  @IsBoolean()
  isHead?: boolean

  @ApiPropertyOptional({ type: 'string', description: "Date d'adhésion" })
  @IsOptional()
  @IsDateString()
  joinedAt?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de départ' })
  @IsOptional()
  @IsDateString()
  leftAt?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Actif' })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean
}
